export const enabledRUMEnvs = ["stg", "prod"];
